// extracted by mini-css-extract-plugin
export default {"section":"Competitions_section__lgFrc","titleContainer":"Competitions_titleContainer__Qr90E","competitionsGrid":"Competitions_competitionsGrid__gbDby"};